<script>
	export default {
		name: 'PurchaseOrderExecuter',
		computed: {
			serverDataPurchaseOrderesolve() {
				return true
			}
		}
	}
</script>